import { NegotiationState } from '../../../generated/graphql';
import { GetSpaceBase } from '../../types/GetSpaceBase';
import { getUndefinedSpace } from '../../utils/getUndefinedSpace';
import { spaceFactory } from '../../utils/spaceFactory';

export const getSpacePra: GetSpaceBase = (group, space, context) => {
  const { negBooleans } = context;
  const {
    isVirtualDebt,
    isPra,
    isACPK,
    isTotalPayment,
    negState,
  } = negBooleans!;

  switch (group) {
    case 'NEG_OPTION': {
      switch (space) {
        case 'description': {
          // Estos comentarios son para tener en cuenta
          // los espacios que se podrían necesitar en caso de que se quiera diferenciar
          // entre virtual debt y no virtual debt, o entre acpk y
          //  total payment dentro de pra. Por ahora, se decidió no hacer
          //  estas diferenciaciones, pero se dejó la lógica pensada para
          // que sea más fácil agregar estos espacios
          // en caso de que se quieran agregar en el futuro.

          /* if (isVirtualDebt && isPra && isTotalPayment) {
            return spaceFactory('NEG_OPTION.description.unification').get();
          }
          if (isVirtualDebt && isPra && isACPK) {
            return spaceFactory('NEG_OPTION.description.unification.acpk').get();
          } */
          if (!isVirtualDebt && isPra && isACPK) {
            return spaceFactory('NEG_OPTION.description.acpk').get();
          }
          if (!isVirtualDebt && isPra && isTotalPayment) {
            return spaceFactory('NEG_OPTION.description.totalPayment').get();
          }
          break;
        }
        case 'state.alert': {
          if (isVirtualDebt && isPra) {
            if (negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.pra.unification').get(); // Conversar
            }
            /* if (negState === NegotiationState.SentToBank
              || negState === NegotiationState.PrepaymentCompleted) {
              return spaceFactory('NEG_OPTION.state.alert.sentToBank.unification').get();
            } */
            return spaceFactory('NEG_OPTION.state.alert.unification').get();
          }
          if (!isVirtualDebt && isPra && isACPK) {
            if (negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.pra.acpk').get();
            }
            if (negState === NegotiationState.PrepaymentCompleted) {
              return spaceFactory('NEG_OPTION.state.alert.PrepaymentCompleted.acpk').get();
            }
            if (negState === NegotiationState.SentToBank) {
              return spaceFactory('NEG_OPTION.state.alert.sentToBank.acpk').get();
            }
            return spaceFactory('NEG_OPTION.state.alert.acpk').get();
          }
          if (!isVirtualDebt && isPra && isTotalPayment) {
            if (negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.pra').get();
            }
            if (negState === NegotiationState.SentToBank
              || negState === NegotiationState.PrepaymentCompleted) {
              return spaceFactory('NEG_OPTION.state.alert.sentToBank').get();
            }
            return spaceFactory('NEG_OPTION.state.alert.totalPayment').get();
          }
          break;
        }
        case 'title': {
          if (isPra && isTotalPayment) {
            return spaceFactory('NEG_OPTION.title.totalPayment').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_OPTION_CONDITIONS': {
      switch (space) {
        case 'benefits.text': {
          /* if (isVirtualDebt && isPra) {
            return spaceFactory('NEG_OPTION_CONDITIONS.benefits.unification').get();
          } */
          if (!isVirtualDebt && isPra && isACPK) {
            return spaceFactory('NEG_OPTION_CONDITIONS.benefits.acpk').get();
          }
          if (!isVirtualDebt && isPra && isTotalPayment) {
            return spaceFactory('NEG_OPTION_CONDITIONS.benefits.totalPayment').get();
          }
          break;
        }
        case 'consequences.text': {
          /* if (isVirtualDebt && isPra) {
            return spaceFactory('NEG_OPTION_CONDITIONS.consequences.unification').get();
          } */
          if (!isVirtualDebt && isPra && isACPK) {
            return spaceFactory('NEG_OPTION_CONDITIONS.consequences.acpk').get();
          }
          if (!isVirtualDebt && isPra && isTotalPayment) {
            return spaceFactory('NEG_OPTION_CONDITIONS.consequences.totalPayment').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_OPTION_SUMMARY': {
      switch (space) {
        case 'alert.conditions': {
          /* if (isVirtualDebt && isPra) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.conditions.unification').get();
          } */
          if (!isVirtualDebt && isPra && isACPK) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.conditions.acpk').get();
          }
          if (!isVirtualDebt && isPra && isTotalPayment) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.conditions.totalPayment').get();
          }
          break;
        }
        case 'alert': {
          /* if (isVirtualDebt && isPra) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.unification').get();
          } */
          if (!isVirtualDebt && isPra && isACPK) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.acpk').get();
          }
          if (!isVirtualDebt && isPra && isTotalPayment) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.totalPayment').get();
          }
          break;
        }
        case 'description': {
          if (isPra && isTotalPayment) {
            return spaceFactory('NEG_OPTION_SUMMARY.description.totalPayment').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_CONFIRMATION': {
      switch (space) {
        case 'alert': {
          /* if (isVirtualDebt && isPra) {
            return spaceFactory('NEG_CONFIRMATION.payment.alert.content').get();
          } */
          if (!isVirtualDebt && isPra && isACPK) {
            return spaceFactory('NEG_CONFIRMATION.payment.alert.acpk').get();
          }
          if (!isVirtualDebt && isPra && isTotalPayment) {
            return spaceFactory('NEG_CONFIRMATION.alert.totalPayment').get();
          }
          break;
        }
        default: break;
      }
      break;
    }

    default: break;
  }

  return getUndefinedSpace();
};
